export const createRequestState = () => ({
  loading: false,
  error: null,
  lastFetch: null,
  status: null,
});

export const requestStarted = (requests, key) => {
  requests[key] = {
    ...(requests[key] || createRequestState()),
    loading: true,
    error: null,
  };
};

export const requestSucceeded = (requests, key, status = "success") => {
  requests[key] = {
    ...(requests[key] || createRequestState()),
    loading: false,
    error: null,
    lastFetch: Date.now(),
    status,
  };
};

export const requestFailed = (requests, key, error) => {
  requests[key] = {
    ...(requests[key] || createRequestState()),
    loading: false,
    error,
    status: "error",
  };
};
